const mutations = {
  // 设置公告列表
  muSetAddToCartInfo(state, data) {
    state.addToCartInfo = data;
  },

  // 暂存选择年级下标
  muClickTabIdx(state, idx) {
    let m = sessionStorage.getItem('shoppingPolymerizeSelectId');
    if (m) {
      state.clickTabIdx = m;
    } else {
      state.clickTabIdx = idx;
    }
  },

  // 设置购物车数量
  muSetShoppingCartCount(state, num) {
    state.shoppingCount = num;
  },

  // 加入购物车
  muAddShoppingCartCount(state, num) {
    state.shoppingCount = state.shoppingCount + num;
  },

  // 设置货架展示数据
  muSetCourseList(state, data) {
    state.curCourseList = data;
  },

  // 设置购物车数量
  muSetSelectedName(state, name) {
    state.selectedName = name;
  },

  // 设置购物车列表已加购商品ID
  muSetShoppingCartListIds(state, data) {
    state.shoppingCartListIds = data;
  }

};
export default mutations;
